export default "__VITE_ASSET__E9o8ZDRG__"